export const blockIconsDeviceLightMode = (
	<span className='material-symbols-outlined'>light_mode</span>
);
